import { convertFormDataToFilesJson } from './generics-conversion-service';
var convertFormDataToAbstractCreateRequest = function convertFormDataToAbstractCreateRequest(data) {
  return {
    files: convertFormDataToFilesJson(data),
    styleOfEnglish: data.styleOfEnglish,
    origin: 'aje'
  };
};
export default convertFormDataToAbstractCreateRequest;